import { useEffect, useState } from 'react';
import { useEventListener } from 'ahooks';

const MIN_WIDTH = 1310;
const MAX_WIDTH = 2560;
const MIN_SCALE = 1;
const MAX_SCALE = 1.4;

const scalePerPix = (MAX_SCALE - MIN_SCALE) / (MAX_WIDTH - MIN_WIDTH);
const width = window.innerWidth;

const useResize = () => {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    /*初始化设置*/
    if (width >= MAX_WIDTH) {
      // @ts-ignore
      document.body.style.zoom = MAX_SCALE;
      document.body.style.width =
        (window.innerWidth - 20) / (1 + (width - MIN_WIDTH) * scalePerPix) +
        'px';

      setZoom(MAX_SCALE);
    } else if (width <= MIN_WIDTH) {
      // @ts-ignore
      document.body.style.zoom = MIN_SCALE;
      document.body.style.width =
        (window.innerWidth - 20) / (1 + (width - MIN_WIDTH) * scalePerPix) +
        'px';
      setZoom(MIN_SCALE);
    } else {
      //zoom方案
      const zoom = 1 + Number(((width - MIN_WIDTH) * scalePerPix).toFixed(2));
      // @ts-ignore
      document.body.style.zoom = zoom;
      document.body.style.width =
        (window.innerWidth - 20) / (1 + (width - MIN_WIDTH) * scalePerPix) +
        'px';
      //transform scale方案
      /* document.documentElement.style.transform=`scale(${1+(width-MIN_WIDTH)*scalePerPix})`
        document.documentElement.style.width=(window.innerWidth-20)/(1+(width-MIN_WIDTH)*scalePerPix)+'px'*/

      setZoom(zoom);
    }
  }, []);

  useEventListener('resize', () => {
    const width = window.innerWidth;
    if (width <= MAX_WIDTH && width >= MIN_WIDTH) {
      //zoom方案
      const zoom = 1 + Number(((width - MIN_WIDTH) * scalePerPix).toFixed(2));
      // @ts-ignore
      document.body.style.zoom = zoom;
      document.body.style.width =
        (window.innerWidth - 20) / (1 + (width - MIN_WIDTH) * scalePerPix) +
        'px';

      //transform scale方案
      /*document.documentElement.style.transform=`scale(${1+(width-MIN_WIDTH)*scalePerPix})`
      document.documentElement.style.width=(window.innerWidth-20)/(1+(width-MIN_WIDTH)*scalePerPix)+'px'*/

      setZoom(zoom);
    }
  });

  return zoom;
};

export default useResize;
